import withBrand from './withBrand';
export default withBrand;